import React, { useCallback, useState } from 'react';
import { useElementIntoView } from '@umu/umu-react-hooks';

interface IProps {
    children: JSX.Element;
    className?: string;
    root?: HTMLElement; // 滚动容器
    intrinsicHeight?: string; // 内容初始高度
}

/**
 * 元素滚动到可见视口的时候再 render。已废弃，请使用 `import LazyRender from 'common/src/components/lazyRender'`
 * @param {children: JSX.Element;root?: HTMLElement;className?: string;intrinsicHeight?: string;}
 * @author Kody
 */
export const LazilyRender = (props: IProps) => {
    const { className = '', children, root, intrinsicHeight } = props;
    const [wrap, setWrap] = useState<HTMLDivElement | null>(null);
    const intoView = useElementIntoView(wrap, true, root);
    const style = { minHeight: !intoView && intrinsicHeight ? intrinsicHeight : 'initial' };

    const eleRef = useCallback((node: any) => {
        if (node) {
            setWrap(node);
        }
    }, []);

    return (
        <div className={className} ref={eleRef} style={style}>
            {intoView ? children : null}
        </div>
    );
};
